import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/Utilstoplogo.svg";
import * as apicall from '../Apicall';
import { TbLogout } from "react-icons/tb";
import { MdPersonOutline } from "react-icons/md";


const AdminNavbar = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const [userInitials, setUserInitials] = useState('U');
  const [bgColor, setBgColor] = useState('#1D4ED8');

  const getInitials = (name) => {
    if (!name) return 'U';
    const names = name.split(' ');
    let initials = names[0].charAt(0).toUpperCase();
    if (names.length > 1) {
      initials += names[names.length - 1].charAt(0).toUpperCase();
    }
    return initials;
  };

  useEffect(() => {
  let isMounted = true;
  
  const fetchUserData = async () => {
    try {
      const response = await apicall.get('myProfile');
      if (isMounted && response.status === 200 && response.data?.length > 0) {
        const user = response.data[0];
        const fullName = `${user.first_name || ''}`.trim();
        setUserInitials(getInitials(fullName));
        setBgColor('#1D4ED8');
      }
    } catch (err) {
      if (isMounted) {
        console.error('Error fetching user data:', err);
      }
    }
  };

  fetchUserData();

  return () => {
    isMounted = false;
  };
}, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top custom-border-bottom py-2">
      <div className="container-fluid px-3 px-lg-4">
        {/* Logo Section */}
        <div className="d-flex align-items-center">
          <div className="d-flex align-items-center">
            <img
              src={logo}
              alt="Logo"
              className="me-2"
              style={{ width: '130px', height: '30px' }}
            />
          </div>
        </div>

        {/* Right Side Items */}
        <div className="d-flex align-items-center gap-4 ms-auto">
          <Dropdown align="end" className="d-flex align-items-center">
            <Dropdown.Toggle
              variant="link"
              className="p-0 border-0 bg-transparent d-flex align-items-center custom-dropdown-toggle"
              id="dropdown-user"
            >
              <div className="rounded-circle d-flex align-items-center justify-content-center me-2"
                style={{ width: '40px', height: '40px', backgroundColor: bgColor }}>
                <span className="text-white" style={{ fontSize: '16px' }}>{userInitials}</span>
              </div>
            </Dropdown.Toggle>

            <style jsx="true">{`
              .custom-dropdown-toggle::after {
                display: none !important;
              }
              .custom-dropdown-toggle:hover {
                text-decoration: none !important;
              }
              .custom-dropdown-toggle {
                text-decoration: none !important;
              }
            `}</style>

          

            <Dropdown.Menu style={{ marginTop: '8px' }}>
              <Dropdown.Item
                onClick={() => navigate('/vendors/view-profile')}
                className="d-flex align-items-center gap-2"
              >
                <MdPersonOutline style={{ fontSize: '24px', color: '#000' }} />
                <span className="form-labels">Profile</span>
              </Dropdown.Item>
              <Dropdown.Item onClick={handleLogout} className="d-flex align-items-center gap-2">
                <TbLogout style={{ color: '#E70000', fontSize: '24px' }} />
                <span className="form-labels" style={{ color: '#E70000' }}>Sign-Out</span>
              </Dropdown.Item>
            </Dropdown.Menu>

          </Dropdown>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar; 